class AngularHelper {
	static register(options) {
		for(var prop in options) {
			AngularHelper[prop] = options[prop];
		}
	}

	static config() {
		return ['$controllerProvider', '$compileProvider', '$filterProvider', '$provide', '$httpProvider',
			($controllerProvider, $compileProvider, $filterProvider, $provide, $httpProvider) => {
				'use strict';

				AngularHelper.register({
					controller: $controllerProvider.register,
					directive: $compileProvider.directive,
					filter: $filterProvider.register,
					factory: $provide.factory,
					service: $provide.service,
					value: $provide.value,
					decorator: $provide.decorator,
					provider: $provide.provider
				});
			}
		];
	}

	static run() {
		return ['$injector', '$q',
			($injector, $q) => {

				function injectFactory(name) {
					var deferred = $q.defer();

					$injector.invoke([name, (factory) => {
						// setTimeout(() => {
							deferred.resolve(factory);
						// }, 1);
					}]);

					return deferred.promise;
				}

				function injectService(name) {
					// console.log( name, $injector.get(name).constructor );
					try {

						var clazz = $injector.get(name).constructor;
						var inst = $injector.instantiate(clazz, {});
						return inst;
					}
					catch(e) {
						console.warn(e);
						return {};
					}

				}

				AngularHelper.inject = {
					factory: injectFactory,
					service: injectService
				};
			}
		]
	}
}

export default AngularHelper;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/angular/AngularHelper.js